import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {markAsArchived} from "../../services/api/apiNextBarcode"
import {pushNewItemHistory} from "../../services/api/apiItemHistory";


class MarkAsArchived extends Component {
    state = {
        loading: false,
    }

    _handleClick = (e) => {
        e.preventDefault()

        this._markAsArchived()
    }

    _markAsArchived = async () => {
        if (this.state.loading) return false

        const r = window.confirm('Do you want to archive this order?')
        if (!r) return false

        this.setState({
            loading: true
        })

        try {
            const {_id} = this.props.item
            const response = await markAsArchived(_id)

            const {success, message} = response

            if (!success) alert(message)

            this.setState({
                loading: false
            }, () => {
                this.props.reloadItems()
                return pushNewItemHistory(`${this.props.item.barcodeNumber}_1`, {
                    event_key: 'archive_order',
                    event_description: 'Archive order.',
                })
            })
        } catch (e) {
            this.setState({
                loading: false
            }, () => {
                window.alert(`Lỗi: ${e.message}`)
            })
        }
    }

    render() {
        return (
            <div className="MarkAsArchived">
                <i title="Archived" className='icon-box-add' onClick={this._handleClick}/>
            </div>
        )
    }
}

MarkAsArchived.propTypes = {
    item: PropTypes.object.isRequired,
    reloadItems: PropTypes.func.isRequired,
}

export default MarkAsArchived
